import { useSessionStore } from '../store/sessionStore';
import { GamePackage } from '../types';
import './PackageSelector.css';

interface PackageSelectorProps {
  packages: GamePackage[];
}

/** Выбор пакета: стартует новую серверную сессию. */
export const PackageSelector = ({ packages }: PackageSelectorProps) => {
  const startPackage = useSessionStore((state) => state.startPackage);
  const session = useSessionStore((state) => state.session);

  return (
    <div className="package-selector">
      <h2 className="package-selector-title">Выберите пакет игры</h2>
      <div className="package-selector-grid">
        {packages.map((pkg) => (
          <button
            key={pkg.id}
            type="button"
            className={`package-card ${session.package?.id === pkg.id ? 'active' : ''}`}
            onClick={() => startPackage(pkg.id)}
          >
            <div className="package-card-name">{pkg.name}</div>
            <div className="package-card-description">{pkg.description}</div>
            <div className="package-card-count">Треков: {pkg.tracks.length}</div>
          </button>
        ))}
      </div>
    </div>
  );
};
